import type { DocumentNode, OperationDefinitionNode } from 'graphql';

export default function getOperationType(doc: DocumentNode): string | null {
  const defenition = doc?.definitions?.find(
    definition => definition.kind === 'OperationDefinition'
  ) as OperationDefinitionNode;

  return defenition?.operation || 'query';
}
